import React from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import { Modal } from 'Components/Modal';
import { Text, Flex, SvgIcon, ButtonFilled } from 'Components/Base';
import { ICON_LIST } from 'Components/Base/Icon/SvgIcon';

const CreatePasswordModal = ({ isActive, onCreatePasswordButtonClick }) => {
  const { t } = useTranslation('classroom');
  return (
    <Modal
      disableTopOffset
      muiProps={{
        isActive,
      }}
      contents={
        <Flex flexDirection={'column'} alignItems={'center'}>
          <SvgIcon icon={ICON_LIST.EMAIL} size={72} color={'primary'} />
          <Text fontSize={7} fontWeight={'medium'} textAlign={'center'} mt={2}>
            <Trans defaults={t('CREATE_PASSWORD_MODAL.TITLE')} components={[<br key="title" />]} />
          </Text>
        </Flex>
      }
      footer={
        <Flex mt={7} justifyContent="center">
          <ButtonFilled
            minWidth={160}
            borderRadius={25}
            onClick={onCreatePasswordButtonClick}
            textColor={'white'}
            fontWeight={600}
          >
            {t('CREATE_PASSWORD_MODAL.BUTTON')}
          </ButtonFilled>
        </Flex>
      }
    />
  );
};

CreatePasswordModal.propTypes = {
  isActive: PropTypes.bool,
  onCreatePasswordButtonClick: PropTypes.func,
};

export default CreatePasswordModal;
